import { HttpErrorResponse } from '@angular/common/http';

export const errMessage = (err: HttpErrorResponse | Error): string => {
  // Handle Angular HttpErrorResponse (server/network errors)
  if (err instanceof HttpErrorResponse) {
    const errorResponse: unknown = err.error;

    // If the response contains validation errors (from class-validator)
    if (
      typeof errorResponse === 'object' &&
      errorResponse !== null &&
      'errors' in errorResponse &&
      Array.isArray((errorResponse as { errors?: unknown }).errors)
    ) {
      const errors = (errorResponse as { errors: unknown[] }).errors.filter(
        (e): e is string => typeof e === 'string' && e.length > 0,
      );

      return errors.join(', '); // Join multiple validation errors into a single string
    }

    // General API error message
    if (
      typeof errorResponse === 'object' &&
      errorResponse !== null &&
      'message' in errorResponse
    ) {
      const msg = (errorResponse as { message?: unknown }).message;
      return typeof msg === 'string' && msg.length > 0 ? msg : 'Request failed';
    }

    // Fallbacks: sometimes err.message is useful, sometimes not
    return err.message.length > 0 ? err.message : 'Request failed';
  }

  // Handle generic JavaScript errors
  return err.message.length > 0 ? err.message : 'Unknown error';
};
